import { useMutation } from '@tanstack/react-query';
import { analyticsTrack } from '../../web-analytics/webAnalytics';
import { AnalyticsEvent } from '../../web-analytics/AnalyticsEvent';
import { useNotification } from '../../notification/notificationsContext';
import { useQueryCacheManager } from '../../hooks/useQueryCacheManager';
import useApi from '../../api/backendApiContext';

export const useReactivateMutation = () => {
  const queryCacheManager = useQueryCacheManager();
  const { billingApi } = useApi();

  const { notifySuccess, notifyError } = useNotification();
  return useMutation(
    async (params: {
      offer: string | null;
      termsAndConditionsAccepted: boolean;
      billingIsRecurringAndImmediateAcknowledged: boolean;
      billingPlan: string;
    }) => billingApi.reactivateBillingPlan(params),
    {
      onSuccess: async (data, params) => {
        await queryCacheManager.updateBillingCustomer(data);
        await queryCacheManager.invalidateInvoices();
        notifySuccess({
          notificationMsg: 'Congratulations! Your account has been successfully reactivated.',
        });
        analyticsTrack(AnalyticsEvent.BILLING_PLAN_REACTIVATED, {
          offer: params.offer ? params.offer : undefined,
        });
      },
      onError: () => {
        notifyError({
          notificationMsg:
            'Something went wrong white reactivating the account. Please try again or contact support@growegy.com',
        });
      },
    }
  );
};
